import { render, staticRenderFns } from "./Kalkulator.vue?vue&type=template&id=80ec615c"
import script from "./Kalkulator.vue?vue&type=script&lang=js"
export * from "./Kalkulator.vue?vue&type=script&lang=js"
import style0 from "./Kalkulator.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports